export default __webpack_public_path__ + "static/media/ayurveda-care-icon.f21ad430.svg";